import React, { FC } from 'react';
import { CollapsibleFactBox, FactBox, Grid } from 'enova-frontend-components';
import { Trans, useTranslation } from 'react-i18next';
import _ from 'underscore';
import { useDispatch } from 'react-redux';

import useSelector from '../../../../hooks/useSelector';
import { getEtasjer } from '../../../../store/registration/selectors';
import { initGulvsoner } from '../../../../store/registration/actions';

import FloorSection from './floorSection';
import { FloorContentWrapper } from './floorContentWrapper';

const Floors: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const etasjer = useSelector((state) => getEtasjer(state), _.isEqual);
  const hasEtasjer = etasjer && etasjer.length > 0;

  if (!etasjer[0]?.gulvSoner || etasjer[0].gulvSoner.length === 0) {
    dispatch(initGulvsoner());
  }

  if (!hasEtasjer) {
    return (
      <FloorContentWrapper>
        <Trans i18nKey="register.areaDetailing.empty.title" />
      </FloorContentWrapper>
    );
  }

  if (etasjer.length === 1) {
    return (
      <FloorContentWrapper>
        <FactBox className="mb-3" title={t('register.floors.sectionTitle')}>
          <FloorSection etasjeId={etasjer[0].id} />
        </FactBox>
      </FloorContentWrapper>
    );
  }

  return (
    <FloorContentWrapper>
      <Grid container spacing={4}>
        {etasjer?.map((etasje, etasjeIndex) => {
          const floorTitle = t('register.floors.sectionTitle', {
            context: etasje.erKjeller ? 'basement' : 'floorNo',
            count: etasje.etasjeNummer
          });

          return (
            <Grid item xs={12} key={etasje.id}>
              <CollapsibleFactBox title={floorTitle} initExpanded={etasjeIndex === 0}>
                <FloorSection etasjeId={etasje.id} />
              </CollapsibleFactBox>
            </Grid>
          );
        })}
      </Grid>
    </FloorContentWrapper>
  );
};

export default Floors;
